import { useSelector } from 'react-redux'
import { selectToken } from '../authentication/authenticationSlice'
import api, { isHTTPError } from '../api'
import useDataLoader from '../dataLoader'

const useGetGA4Email = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  const fetchGA4Email = async () => {
    if (organizationId) {
      try {
        return await api.getGA4Emails({ token, organizationId })
      } catch (error) {
        if (isHTTPError(error) && error.response.status === 404) {
          return null
        } else if (isHTTPError(error) && 'detail' in error.response.data) {
          throw new Error(
            'Error loading GA4 emails: ' + error.response.data.detail.type
          )
        } else {
          throw error
        }
      }
    }
  }

  return useDataLoader(fetchGA4Email, [], [])
}

export default useGetGA4Email
